var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCabinbaggageIconNotActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7C6769B5-0653-4EF8-A86C-470548F1EC36") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transavia-LuggagePerPassenger",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transavia",
    transform: "translate(-47, -5464)",
    fill: "#8F8F8F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transavia/LuggageAdded/MD-992/2Travellers",
    transform: "translate(24, 4135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transavia/Reiziger1",
    transform: "translate(0, 1092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Small/Hand-luggage-Copy",
    transform: "translate(23, 237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.01190615,0.9 L8.81190615,0.9 L8.81190615,3.6 L9.71190615,3.6 L9.71190615,0.45 C9.71190615,0.2 9.51190615,0 9.26190615,0 L6.56190615,0 C6.31190615,0 6.11190615,0.2 6.11190615,0.45 L6.11190615,3.55 L7.01190615,3.55 L7.01190615,0.9 L7.01190615,0.9 Z M10.1119062,4.45 L5.66190615,4.45 C4.91190615,4.45 4.31190615,5.05 4.31190615,5.8 L4.31190615,12.85 C4.31190615,13.6 4.91190615,14.2 5.66190615,14.2 L10.1119062,14.2 C10.8619062,14.2 11.4619062,13.6 11.4619062,12.85 L11.4619062,5.8 C11.4619062,5.05 10.8619062,4.45 10.1119062,4.45 L10.1119062,4.45 Z M5.41190615,14.5 C5.81190615,14.5 6.16190615,14.85 6.16190615,15.25 C6.16190615,15.65 5.86190615,16 5.41190615,16 C4.96190615,16 4.66190615,15.65 4.66190615,15.25 C4.66190615,14.85 5.01190615,14.5 5.41190615,14.5 L5.41190615,14.5 Z M10.3619062,14.5 C10.7619062,14.5 11.1119062,14.85 11.1119062,15.25 C11.1119062,15.65 10.7619062,16 10.3619062,16 C9.96190615,16 9.61190615,15.65 9.61190615,15.25 C9.61190615,14.85 9.91190615,14.5 10.3619062,14.5 L10.3619062,14.5 Z",
    id: "Combined-Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinbaggageIconNotActive);
export default __webpack_public_path__ + "static/media/cabinbaggage-icon-not-active.e657fc33951b29797eaef27ecfa129b8.svg";
export { ForwardRef as ReactComponent };